import React from 'react';
import PropTypes from 'prop-types';
import ListSelectTreeSource from './ListSelectTreeSource';
import ListSelectTreeTarget from './ListSelectTreeTarget';
import { Icon } from 'antd';
import classNames from 'classnames';
import { deepClone } from '@/utils/common';
import './style/index.less';

function noop() {}

export default class TransferSelectTree extends React.Component {
  static defaultProps = {
    prefixCls: 'antui-transfer-selecttree',
    sourceNodes: [],
    onChange: noop,
    treeKey: 'key',
    treeTitleKey: 'title',
    showSearch: false,
    disabled: false,
    footer: noop,
    loading: false
  };

  static propTypes = {
    prefixCls: PropTypes.string,
    sourceNodes: PropTypes.array,
    targetNodes: PropTypes.array,
    onChange: PropTypes.func,
    listStyle: PropTypes.object,
    listRender: PropTypes.func,
    treeKey: PropTypes.string,
    treeTitleKey: PropTypes.string,
    className: PropTypes.string,
    titleText: PropTypes.string,
    showSearch: PropTypes.bool,
    searchPlaceholder: PropTypes.string,
    notFoundContent: PropTypes.node,
    disabled: PropTypes.bool,
    footer: PropTypes.func,
    treeRender: PropTypes.func,
    loadData: PropTypes.func,
    loading: PropTypes.bool,
    asyncSearch: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      leftFilter: '',
      rightFilter: '',
      sourceNodes: props.sourceNodes,
      targetNodes: props.targetNodes,
      checkedKeys: props.targetNodes
        ? props.targetNodes.map(node => node[props.treeKey])
        : null
    };
    if (props.showSearch) {
      this.flatLeftTreeData = this.getFlatTreeData(props.sourceNodes);
      this.flatRightTreeData = this.getFlatTreeData(props.targetNodes);
    }
  }

  getFlatTreeData(treeData) {
    let data = [];
    treeData.forEach(item => {
      if (item.children) {
        data = data.concat(this.getFlatTreeData(item.children));
      }
      
      data.push(item);
    });
    return data;
  }

  componentWillReceiveProps(nextProps) {
    const { targetNodes, sourceNodes } = nextProps;
    if (
      nextProps.targetNodes !== this.props.targetNodes ||
      nextProps.sourceNodes !== this.props.sourceNodes
    ) {
      if (targetNodes) {
        this.setState({
          targetNodes: targetNodes,
          checkedKeys: targetNodes.map(node => node[nextProps.treeKey])
        })
      }
      if (sourceNodes) {
        this.setState({
          sourceNodes: sourceNodes
        });
      }
      if (nextProps.showSearch) {
        this.flatLeftTreeData = this.getFlatTreeData(sourceNodes);
        this.flatRightTreeData = this.getFlatTreeData(targetNodes);
      }
    }
  }

  handleFilter = (direction, v) => {
    this.setState({
      [`${direction}Filter`]: v
    });
  };

  handleLeftFilter = v => this.handleFilter('left', v);
  handleRightFilter = v => this.handleFilter('right', v);

  handleClear = direction => {
    this.setState({
      [`${direction}Filter`]: ''
    });
  };

  handleRightClear = () => this.handleClear('right');
  handleDeleteItem = nodes => {
    const { treeKey } = this.props;
    const targetNodes = this.state.targetNodes.filter(
      node => !nodes.some(item => item[treeKey] === node[treeKey])
    );
    const targetKeys = targetNodes.map(node => node[treeKey]);

    this.setState({
      checkedKeys: targetKeys,
      targetNodes: targetNodes
    });

    this.props.onChange && this.props.onChange(targetKeys, targetNodes);
  };

  forEachChildList = (childList, tempMap) => {
    childList.map(item => {
      tempMap.set(item.key, item);

      //遍历子节点
      item.children && this.forEachChildList(item.children, tempMap);
    });
  }

  findAndAddParentNode = (item, sourceNodeMap, treeDataMap) => {
    if (item.pid === "-1" || !sourceNodeMap.get(item.pid)) return;
    
    //对象需要克隆一下才能用，如果直接用对象引用，会在后面 createTreeNodes 组树修改出问题。
    let parentNode = (origin => {
      if (!origin) return null;

      return deepClone(origin);
    })(sourceNodeMap.get(item.pid));

    if (!treeDataMap.get(parentNode.key)) {
      treeDataMap.set(parentNode.key, parentNode);
    }

    this.findAndAddParentNode(parentNode, sourceNodeMap, treeDataMap);
  }

  findAndAddChildNode = (item, sourceNodeMap, treeDataMap) => {
    if (!item.children) return;

    //遍历子节点
    item.children.map(child => {
      //对象需要克隆一下才能用，如果直接用对象引用，会在后面 createTreeNodes 组树修改出问题。
      let childNode = (origin => {
        if (!origin) return null;

        return deepClone(origin);
      })(sourceNodeMap.get(child.key));

      if (!treeDataMap.get(childNode.key)) {
        treeDataMap.set(childNode.key, childNode);
      }

      this.findAndAddChildNode(childNode, sourceNodeMap, treeDataMap);
    });
  }

  findAndRemoveChildNode = (item, sourceNodeMap, treeDataMap) => {
    if (!item.children) return;

    //遍历子节点
    item.children.map(child => {
      //对象需要克隆一下才能用，如果直接用对象引用，会在后面 createTreeNodes 组树修改出问题。
      let childNode = (origin => {
        if (!origin) return null;

        return deepClone(origin);
      })(sourceNodeMap.get(child.key));

      if (treeDataMap.get(childNode.key)) {
        treeDataMap.delete(childNode.key);
      }

      this.findAndRemoveChildNode(childNode, sourceNodeMap, treeDataMap);
    });
  }

  onChecked = (_checked, _checkedNodes, _node) => {
    const { treeKey, treeTitleKey } = this.props;
    
    let targetNodes = _checkedNodes.map(node => ({
      [treeKey]: node[treeKey],
      [treeTitleKey]: node[treeTitleKey],
      ...node.props
    }));

    const { sourceNodes } = this.state;

    /**
     * 坑人的antd，不提供选择节点自动勾选其下所有子节点，和勾选节点自动勾选其所有上层父节点直到根节点功能
     *            不提供取消选择节点自动取消勾选其下所有子节点
     * 没有EXTJS好用啊。。。
     * 
     * 遍历左边源列表 checked 节点数据，需要将节点找出其每上层的所有上级节点，并且其每下层的所有下级节点展示出来
     * 
     * 第一步：取出左边源列表的所有节点数据，封装成Map
     * 
     * 第二步，取出checked 节点数据，封装成Map
     * 
     * 第三步，如果当前节点是选中状态则找出当前checked节点，其每上层的所有上级节点，和其每下层的所有下级节点
     *        如果当前节点是取消选中状态则取消勾选其下所有子节点
     * 
     */

    //第一步
    let sourceNodeMap = new Map();
    sourceNodes.map(item => {
      sourceNodeMap.set(item.key, item);

      //遍历子节点
      item.children && this.forEachChildList(item.children, sourceNodeMap);
    });

    //第二步，checked 节点数据都是分散的node，不需要遍历子节点
    let treeDataMap = new Map();
    targetNodes.map(item => {
      treeDataMap.set(item.key, item);
    });

    //第三步
    if (_checked === true) {//节点选中状态
      this.findAndAddParentNode(_node.props, sourceNodeMap, treeDataMap);
      this.findAndAddChildNode(_node.props, sourceNodeMap, treeDataMap);
    } else {//节点失去选中状态
      this.findAndRemoveChildNode(_node.props, sourceNodeMap, treeDataMap);
    }
    

    //对Map进行遍历，把新增过所有上下级树节点的checked 节点数据给treeData
    let treeData = [];
    treeDataMap.forEach((value, key, map) => {
      treeData.push(value);
    });

    const treeDataKeys = treeData.map(node => node[treeKey]);

    this.setState({
      checkedKeys: treeDataKeys,
      targetNodes: treeData
    });

    this.props.onChange && this.props.onChange(treeDataKeys, treeData);
  };

  render() {
    const {
      prefixCls,
      showSearch,
      notFoundContent,
      treeKey,
      treeTitleKey,
      searchPlaceholder,
      disabled,
      footer,
      style,
      className,
      treeRender,
      loadData,
      loading,
      asyncSearch,
      sourceTitle,
      targetTitle
    } = this.props;
    
    const { leftFilter, rightFilter, checkedKeys, targetNodes, sourceNodes } = this.state;

    const cls = classNames({
      [className]: !!className,
      [prefixCls]: true
    });

    return (
      <div className={cls}>
        {disabled === false ? (
          <div style={{display: "inline-block"}}>
            <ListSelectTreeSource
              titleText={sourceTitle ? sourceTitle: '源列表'}
              loadData={loadData}
              asyncSearch={asyncSearch}
              treeData={sourceNodes}
              flatTreeData={this.flatLeftTreeData}
              checkedKeys={checkedKeys}
              checkedNodes={targetNodes}
              treeKey={treeKey}
              treeTitleKey={treeTitleKey}
              treeRender={treeRender}
              style={style}
              filter={leftFilter}
              handleFilter={this.handleLeftFilter}
              onChecked={this.onChecked}
              showSearch={showSearch}
              searchPlaceholder={searchPlaceholder}
              notFoundContent={notFoundContent}
              footer={footer}
              prefixCls={`${prefixCls}-list`}
              loading={loading}
            />
            <div className={`${prefixCls}-operation`}>
              <Icon type="right" />
            </div>
          </div>
        ) : null}
        <ListSelectTreeTarget
          titleText={targetTitle ? targetTitle: '目标列表'}
          asyncSearch={asyncSearch}
          treeData={targetNodes}
          flatTreeData={this.flatRightTreeData}
          treeKey={treeKey}
          treeTitleKey={treeTitleKey}
          treeRender={treeRender}
          style={style}
          filter={rightFilter}
          handleFilter={this.handleRightFilter}
          showSearch={showSearch}
          searchPlaceholder={searchPlaceholder}
          notFoundContent={notFoundContent}
          footer={footer}
          prefixCls={`${prefixCls}-list`}
          loading={loading}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TransferSelectTree/TransferSelectTree.js